import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MeetingAvailability } from '@prisma/client';
import { MeetingAvailabilityResourceTypeMappings } from '@aa/nest/resource';
import { meetingAvailabilityCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class MeetingAvailabilityService extends BaseResourceService<MeetingAvailabilityResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'meeting-availabilities');
  }
}
